// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1-Au-","alphaMark":"Header_alphaMark__2XXY8","logo":"Header_logo__19-GP"};